export enum AuthStorage {
  LOCAL_STORAGE = 'local_storage',
  SESSION_STORAGE = 'session_storage',
}
